<template>
  <div>
    <v-row class="text-center" justify="space-between">
      <v-col cols="auto">
        <v-checkbox v-model="item.isChecked" class="ma-0 pa-0"></v-checkbox
      ></v-col>
      <v-col cols="2">{{ item.xmfah }}</v-col>
      <v-col cols="1">{{ item.xmmc }}</v-col>
      <v-col cols="2">{{ item.htbh }}</v-col>
      <v-col cols="1">{{ item.emailStr2 }}</v-col>
      <v-col cols="1">{{ Utility.fmtTime(item.expireDate) }}</v-col>
      <v-col cols="1">{{ Utility.fmtTime(item.dbilldate) }}</v-col>
      <v-col cols="1">{{ item.statusName }}</v-col>
      <v-col cols="2">
        <!-- 结题报告的项目的特殊处理start -->
        <v-tooltip
          bottom
          v-if="item.previewFlag"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="reportPreview(item)"
              >结题报告</v-btn
            >
          </template>
          <span>预览结题报告并确认对账单</span>
        </v-tooltip>

        <v-tooltip
          bottom
          v-if="
            item.previewFlag && showReportListNewStatus.includes(item.newStatus) &&
            (item.pdfFlag || item.analyseFlag)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="report"
              >分析结果</v-btn
            >
          </template>
          <span>预览或下载报告</span>
        </v-tooltip>

        <v-tooltip
          bottom
          v-if="
            item.previewFlag && showAnalyseNewStatus.includes(item.newStatus) &&
            !item.pdfFlag &&
            item.analyseFlag &&
            !(item.rule && item.rule.isAnalysis === false)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="analyse"
              >交互分析</v-btn
            >
          </template>
          <span>在线辅助分析</span>
        </v-tooltip>

        <v-tooltip
          bottom
          v-if="
            item.previewFlag && item.newStatus == 8 &&
            item.sourcefileurl &&
            (item.pdfFlag || item.analyseFlag)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="file"
              >原始数据</v-btn
            >
          </template>
          <span>获取原始文件下载地址</span>
        </v-tooltip>

        <!-- 结题报告的项目的特殊处理end,以下为原逻辑 -->
        <v-tooltip
          bottom
          v-if="
            !item.previewFlag && showReportListStatus.includes(item.status) &&
            (item.pdfFlag || item.analyseFlag)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="report"
              >分析结果</v-btn
            >
          </template>
          <span>预览或下载报告</span>
        </v-tooltip>

        <!-- <v-tooltip
          bottom
          v-if="
            !item.previewFlag && showConfirmStatus.includes(item.status) &&
            (item.pdfFlag || item.analyseFlag) &&
            !item.handleConfirm
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="confirm"
              >确认</v-btn
            >
          </template>
          <span>对报告无异议，请提交确认单</span>
        </v-tooltip> -->

        <v-tooltip
          bottom
          v-if="
            !item.previewFlag && showAnalyseStatus.includes(item.status) &&
            !item.pdfFlag &&
            item.analyseFlag
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="analyse"
              >分析</v-btn
            >
          </template>
          <span>在线辅助分析</span>
        </v-tooltip>

        <v-tooltip
          bottom
          v-if="
            !item.previewFlag && showFileStatus.includes(item.status) &&
            item.sourcefileurl &&
            (item.pdfFlag || item.analyseFlag)
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              text
              color="primary"
              @click="file"
              >原始数据</v-btn
            >
          </template>
          <span>获取原始文件下载地址</span>
        </v-tooltip>

        <v-tooltip
          bottom
          v-if="
            !item.previewFlag && showReportListStatus.includes(item.status) &&
            !item.pdfFlag &&
            !item.analyseFlag
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn small class="text--disabled" text v-bind="attrs" v-on="on"
              >无操作按钮？
              <v-icon small class="text--disabled"
                >mdi-information-outline</v-icon
              >
            </v-btn>
          </template>
          <span
            >您好！如果没有可操作的按钮，可能此时报告文件还未上传完整。请联系销售人员处理，带来不便，敬请谅解。</span
          >
        </v-tooltip>
      </v-col>
    </v-row>
    <!-- loading -->
    <v-dialog v-model="zipLoading" persistent max-width="450">
      <v-card min-height="200">
        <v-card-title>
          <v-icon class="mdi-spin mr-2">mdi-timer-sand</v-icon>
          文件正在打包, 请耐心等待...
        </v-card-title>
        <v-card-text class="pl-6 pr-6">
          <v-row justify="center">
            <v-col cols="auto">
              <span v-text="zipTimer" class="text-h1"></span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 报告列表 -->
    <report v-model="showReport" :data="reportData" :item="item" />
    <!-- 确认报告 -->
    <confirm v-model="showConfirm" :data="item" v-on="$listeners" />
    <!-- 原始文件信息 -->
    <origin-file v-model="showOriginFile" :data="item" v-on="$listeners" />
  </div>
</template>
<script>
/**
 * OAProject
 * ---- 转换项:
 * csj: 项目类型
 * type: 通过csj转换为报告类型
 * invalidDt: 有效日期
 * xmh: ypbh
 * analyseFlag: 是否是在线报告
 * pdfFlag: 是否在指定目录下存在pdf文件(当analyseFlag为false的时候,才判断这个属性)
 * reportId: 报告id
 * schemaList: 交互式分析方案列表
 * ---- 新增项:
 * zt: 状态, cf:是否已确认, nf(X): X通知是否已发送
 *
 * 在线报告: /类型/项目号/xxx
 *  1, 目录下有对应的Schema
 *  2, 文件全部下载的时候,对应为: /{type}/{xmh}/报告与附件.zip
 * pdf报告:
 *  1, 预览: /rep/{xmh}/report.pdf
 *  2, 全部下载: /rep/{xmh}/报告与附件.pdf
 */
// import { userProjectDetail } from "@/plugins/api";
import { asg } from "@/plugins/chart";
import report from "./report.vue";
import confirm from "./confirm.vue";
import originFile from "./originFile.vue";
export default {
  components: {
    report,
    confirm,
    originFile,
  },
  props: ["item"],
  data() {
    return {
      zipLoading: false,
      zipTimer: 0,
      showReport: false,
      showReportListStatus: ["4", "5", "6", "7"], //可以展示报告列表的状态
      reportData: [], //报告列表参数
      showConfirm: false,
      showConfirmStatus: ["4"], //可以展示确认报告的状态
      showAnalyseStatus: ["6", "7"], //可以展示分析的状态
      showFileStatus: ["7"], //可以展示文件的状态
      showOriginFile: false,
      showReportListNewStatus: ["6", "7", "8"], //可以展示报告列表的新状态
      showAnalyseNewStatus: ["7", "8"], //可以展示分析的状态
    };
  },
  computed: {
    zt() {
      let ztName = undefined;
      asg.status.forEach((item) => {
        if (item.value == this.item.status) {
          //其它状态
          ztName = item.name;
        }
      });
      if (this.item.confirmStatus == "0") {
        ztName = `${ztName}<strong style="color: red;">（报告确认失败，请联系客服人员。）</strong>`;
      } else if (this.item.handleConfirm) {
        ztName = "报告确认中";
      }
      return ztName;
    },
    analyseURL() {
      return `/report/analyse?reportId=${this.item.reportId}&schema=Schema&xmh=${this.item.projectNo}&xmfah=${this.item.xmfah}&htbh=${this.item.htbh}&csj=${this.item.csj}&ypbh=${this.item.ypbh}`;
    },
  },
  methods: {
    analyse() {
      if (this.item.newVersionFlag == '1') {
        window.open(`${window.location.origin}/plus/#/result/overview?project=${this.item.projectNo}&reportId=${this.item.reportId}`)
      } else {
        window.open(this.analyseURL, "_blank");
      }
      
    },
    report() {
      this.reportData = this.item.reportList;
      this.showReport = true;
    },
    confirm() {
      this.showConfirm = true;
    },
    file() {
      this.showOriginFile = true;
    },
    reportPreview(item) {
      window.open(item.previewUrl, "_blank");
    }
  },
};
</script>
